import { render } from "./PackagePricingCard.vue?vue&type=template&id=4cf55b22"
import script from "./PackagePricingCard.vue?vue&type=script&lang=js"
export * from "./PackagePricingCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__